export default function Banner2({ _data }) {
    return (
        <div className="wt-bnr-inr1 overlay-wraper bg-center" style={{ backgroundImage: `url(${_data.background})` }}>  
            
        </div>
    );
}
